/**
 * Focus handler for button elements that scrolls the focused button into view.
 *
 * Configuration:
 * - behavior: 'smooth' - Provides smooth scrolling animation
 * - block: 'nearest' - Prevents unnecessary vertical scrolling
 * - inline: 'center' - Centers the element horizontally in the scrollable container
 *
 * Includes error handling for browser compatibility and graceful degradation.
 *
 * @example
 * <button onFocus={handleButtonFocus}>
 *   Click me
 * </button>
 */
export const handleButtonFocus = (event) => {
    const element = event.currentTarget;
    // Check if scrollIntoView is supported
    if ('scrollIntoView' in element) {
        try {
            // Try modern API with options
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
        catch (_a) {
            // Fallback to basic scrollIntoView for older browsers
            try {
                element.scrollIntoView();
            }
            catch (_b) {
                // Fail silently - focus still works, just no auto-scroll
            }
        }
    }
};
